<template>
    <div class="artist-preview"
        :class="{
            row: props.row,
            invert: props.invert,
            disabled: props.disabled,
            skeleton: props.skeleton
        }"
    >
        <div>
            <div class="profile-image" :class="{ disabled: false }">
                <Img v-if="profileImage?.resized || defaultProfileImage?.resized || props.skeleton"
                    :preview="props.skeleton ? null : profileImage?.resized || defaultProfileImage?.resized"
                    :original="props.skeleton ? null : profileImage?.original || defaultProfileImage?.original"
                    :skeleton="true"
                    aspectRatio="1 / 1"
                />

               <!--  <AudioToggle v-if="props.item?.wave"
                    :state="data.state"
                    @play="play"
                    @pause="data.state = 'pause'"
                /> -->
            </div>
            <State v-if="!props.row && props.showState && props.item?.state" 
                :state="props.item?.state"
                class="solid" />
        </div>
        <div>
            <div>
                <span class="name">
                    {{ props.item?.name || t('artists.empty-name') }}
                </span>
               
                <State v-if="props.row && props.showState && props.item?.state" 
                    :state="props.item?.state"
                />
            </div>
        </div>
        <div v-if="props.chevron" class="chevron">
            <Icon icon="chevron-right" sprite="navigation" />
        </div>
        <div v-if="props.showKebab">
            <IconButton
                @click.stop="openKebab"
                class="size-s tertiary"
                icon="more-vertical" sprite="navigation"
            />
        </div>
    </div>
</template>

<script setup>
    import { onMounted, reactive, computed } from 'vue';
    import { useI18n } from 'vue-i18n';
    import moment from 'moment';
    import Button from '🔗/components/ui/Button.vue';
    import IconButton from '🔗/components/ui/IconButton.vue';
    import Img from '🔗/components/ui/Img.vue';
    // import AudioToggle from '🔗/components/ui/AudioToggle.vue';
    // import api from '🔗/api';
    import stores from '@/stores';
    import State from '🔗/components/ui/State.vue';

    const modals = stores.modals();
    // const player = stores.player();


    const emit = defineEmits(['change']);

    const { t } = useI18n();

    const props = defineProps({
        item: { type: Object, default: () => ({}) },
        showState: { type: Boolean, default: false },
        row: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        invert: { type: Boolean, default: false },
        skeleton: { type: Boolean, default: false },
        showKebab: { type: Boolean, default: false },
        chevron: { type: Boolean, default: false }
    });

    const profileImage = computed(() => {
        let url;
        if (props.item?.profileImage instanceof File) {
            url = URL.createObjectURL(props.item.profileImage);
        }

        return url ? {
            resized: url,
            cover: url,
            original: url
        } : props.item?.profileImage;
    });

    const data = reactive({
    });

    const openKebab = () => {
        modals.open('artist-kebab', { quietClose: true, data: { code: props.item?.code } })
    }

    const defaultProfileImage = computed(() => {
        return api.artists().defaultProfileImage;
    });


    const play = async () => {
        // data.state = 'play';

        // if (!data.song) {
        //     data.song = await player.song(props.item); 
        // console.log(data.song);
        // }

        // data.song.play();
    }

    // onMounted(() => {
    //     getItems();
    // });
</script>

<style lang="scss" scoped>
    .artist-preview {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 16px;
        width: 100%;
        overflow: hidden;
        & > div {
            &:first-child {
                display: flex;
                flex-direction: column;
                gap: 8px;
                align-items: center;
                position: relative;

                .profile-image {
                    width: 120px;
                    height: 120px;
                    position: relative;

                    .skeleton-wrapper,
                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        object-fit: cover;
                        overflow: hidden;
                    }

                    .audio-toggle {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                    }

                    &.disabled {
                        filter: grayscale(1);
                        .skeleton-wrapper,
                        img {
                            cursor: default;
                        }
                    }
                }

                .state {
                    position: absolute;
                    right: 8px;
                    top: 8px;
                }
            }
            &:nth-child(2) {
                display: flex;
                flex-direction: column;
                gap: 4px;
                flex: 1;
                min-width: 0;
                align-items: center;

                & > div {
                    display: flex;
                    flex-direction: row;
                    align-items: baseline;
                    gap: 4px;
                    min-width: 0;

                    &:first-child {
                        flex-wrap: nowrap;
                    }
                    // &:last-child {
                    //     flex-direction: column;
                    //     width: 100%;
                    //     span {
                    //         display: flex;
                    //         flex-direction: row;
                    //         gap: 4px;
                    //     }
                    // }

                    .name {
                        font: var(--font-body-1);
                        color: var(--dark-500);
                        // white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        text-align: left;
                        &.full {
                            flex-shrink: 0;
                        }
                    }

                    .state {
                        margin-left: 4px;
                    }
                }
            }
            &:nth-child(3) {
                display: flex;
                flex-direction: column;
                flex-shrink: 0;
            }

            &.chevron {
                margin-left: auto;
                display: flex;
                align-items: center;
                svg {
                    width: 18px;
                    height: 18px;
                    fill: var(--dark-500);
                }
            }
        }

        &.disabled {
            opacity: .4;
            filter: grayscale(1);
            cursor: default;
        }

        &.row {
            gap: 12px;
            flex-direction: row;
            & > div {
                &:first-child {
                    .profile-image {
                       width: 46px;
                       height: 46px;
                    }

                    .state {
                    }
                }
                &:nth-child(2) {
                    justify-content: center;
                    align-items: start;
                    & > div {
                        &:first-child {
                        }
                        &:last-child {
                            align-items: start;
                        }

                        
                    }
                }
            }
        }


        &.invert {
            & > div:nth-child(2) {
                & > div {
                    .title {
                        color: var(--white-500);           
                    }
                }
            }
        }

        &.skeleton {
            & > div:nth-child(2) {
                & > div {
                    position: relative !important;
                    color: transparent !important;
                    @include skeleton;

                    &:nth-child(1) {
                        max-width: 120px;
                        .name {
                            opacity: 0;
                        }
                    }
                }

            }
        }
    }
</style>
